export default __webpack_public_path__ + "static/media/logo03.be7c6488.svg";